import { createSlice } from '@reduxjs/toolkit';

const initialState = {
    filters: {
        "search": "",
        "sort": {
            "attributes": ["uploadedDate"],
            "sorts": ["desc"]
        },
        "filters":[
        ],
        "pageNo": 1,
        "itemsPerPage": 9
    },
    categoryfilter: {
        "listType":"dg_review_category",
        "replacements":["%%"]
    },
};

const dgReviewSlice = createSlice({
    name: 'dgReview',
    initialState,
    reducers: {
        updateFilter: (state, action) => {
            state.filters = action.payload;
        },
        updateDgReviewFilter: (state, action) => {
            state.filters = action.payload;
        },
        updateReducer: (state, action) => {
            state.filters = action.payload;
        },
    },
});

export const {
    updateFilter,
    updateReducer,
    updateDgReviewFilter,
} = dgReviewSlice.actions;

export default dgReviewSlice.reducer;
